import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-x1" }
const _hoisted_2 = { class: "flex mb-x2" }
const _hoisted_3 = { class: "w-1/3" }
const _hoisted_4 = { class: "w-1/3" }
const _hoisted_5 = { class: "w-1/3 text-right" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { OpeningHours } from '@/types/locationServerApi';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletOpeningHours',
  props: {
    openingHours: null
  },
  setup(__props: any) {



const showAll = ref(false);

const limit = computed(() => showAll.value ? 10 : 7);

const blockLabels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("strong", null, _toDisplayString(_unref(blockLabels).openingHours), 1),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.openingHours.slice(0, _unref(limit)), (opening) => {
        return (_openBlock(), _createElementBlock("div", {
          key: opening.startTime.toString()
        }, [
          _createVNode(_Transition, {
            name: "o-anim-fade-600",
            mode: "out-in",
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(opening.shortFormattedDay), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(opening.formattedDate), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(opening.isClosed ? _unref(blockLabels).closed : opening.formattedTime), 1)
              ])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128)),
      (__props.openingHours.length > 7 && !showAll.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "c-magic-line text-dusty-grey",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showAll.value = true))
          }, _toDisplayString(_unref(blockLabels).seeMoreOpeningHours), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})